export default "__VITE_ASSET__jYxbSk49__"